import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keyword' content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'Bienvenidos OnRoadCR',
  description: 'Energia Limpia',
  keywords: 'Planeta Saludable, Verde, Energia Limpia, Medio Ambiente',
};

export default Meta;
